import { render, staticRenderFns } from "./HbSection.vue?vue&type=template&id=675054d1&scoped=true"
import script from "./HbSection.vue?vue&type=script&lang=js"
export * from "./HbSection.vue?vue&type=script&lang=js"
import style0 from "./HbSection.vue?vue&type=style&index=0&id=675054d1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675054d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('675054d1')) {
      api.createRecord('675054d1', component.options)
    } else {
      api.reload('675054d1', component.options)
    }
    module.hot.accept("./HbSection.vue?vue&type=template&id=675054d1&scoped=true", function () {
      api.rerender('675054d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/hubee/HbSection.vue"
export default component.exports